import toV1 from '@builder4/shared/migrations/style/versions/v1';
import toV2 from '@builder4/shared/migrations/style/versions/v2';
import toV3 from '@builder4/shared/migrations/style/versions/v3';
import toV4 from '@builder4/shared/migrations/style/versions/v4';
import type { Migration } from '@builder4/shared/migrations/types';

export const CURRENT_STYLE_VERSION = 4;

/**
 * Migration registry containing all GlobalStyle schema migrations.
 *
 * See ./documents/migrations.md for more information on how to add a new migration.
 */
export const migrations: Migration[] = [
  {
    version: 1,
    migrate: toV1,
  },
  {
    version: 2,
    migrate: toV2,
  },
  {
    version: 3,
    migrate: toV3,
  },
  {
    version: 4,
    migrate: toV4,
  },
];
